import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Clock, LogOut, Shield } from "lucide-react";

export default function PendingApproval() {
  const { user, logout, settings } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const disconnect = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-white flex items-center justify-center p-6">
      <div
        data-testid="pending-approval-screen"
        className="max-w-md w-full rounded-3xl border border-[#E5B85C]/40 bg-gradient-to-br from-slate-900 to-[#0B0F17] p-8 text-center relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#E5B85C]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />
        <div className="relative">
          <div className="mx-auto w-16 h-16 rounded-full bg-[#E5B85C]/15 border border-[#E5B85C]/40 flex items-center justify-center mb-4">
            <Clock className="w-8 h-8 text-[#E5B85C]" />
          </div>
          <div className="text-[11px] font-mono-stat uppercase tracking-[0.25em] text-[#E5B85C] mb-2">
            Compte en attente
          </div>
          <h1 className="font-display font-black text-3xl uppercase tracking-tight">
            Bienvenue {user.name?.split(" ")[0]}
          </h1>
          <p className="text-sm text-slate-300 mt-4 leading-relaxed">
            Ton compte a bien été créé pour rejoindre <b className="text-white">{settings?.app_name || "ASS les Régionnaires"}</b>.
            Le Directeur technique doit valider ton inscription avant que tu puisses accéder à l'effectif et aux matchs.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-800/60 border border-white/10 text-xs text-slate-400">
            <Shield className="w-4 h-4 text-[#E5B85C]" />
            Tu recevras un email dès validation.
          </div>
          <div className="mt-6 flex flex-col gap-2">
            <button
              data-testid="pending-refresh"
              onClick={() => window.location.reload()}
              className="w-full px-4 py-3 rounded-lg bg-[#E5B85C] hover:bg-[#D4A24E] text-[#0B0F17] font-bold uppercase tracking-wide"
            >
              Vérifier à nouveau
            </button>
            <button
              data-testid="pending-logout"
              onClick={disconnect}
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs uppercase tracking-wide font-bold"
            >
              <LogOut className="w-3.5 h-3.5" /> Déconnexion
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
